import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/campaign/joe_post.png'
import _imports_1 from '@/assets/img/info/close_btn.png'
import _imports_2 from '@/assets/img/campaign/joe.png'
import _imports_3 from '@/assets/img/campaign/parts/campaign_login.png'
import _imports_4 from '@/assets/img/campaign/parts/campaign_new.png'
import _imports_5 from '@/assets/img/campaign/amazon-card.png'
import _imports_6 from '@/assets/img/campaign/joe_solo.png'


const _withScopeId = n => (_pushScopeId("data-v-6f18de9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "campaign-container info"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "joe" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_3 = {
  key: 0,
  class: "campaign info"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ご訪問ありがとうございます！", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ジョーズ", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("・")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "タウン", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ログイン", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "キャンペーン", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("」")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "の応募ハガキを", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "進呈", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "しますので、", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ポストを", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "見つけてご応募ください！", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "align-center" }
const _hoisted_19 = {
  key: 0,
  class: "campaign-container main"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "joe" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "banner",
  src: _imports_3
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode(" ご参加ありがとうございます！"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ご希望の賞品をお選びください。 ")
], -1))
const _hoisted_23 = { class: "list" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "list-item-l" }
const _hoisted_26 = { class: "list-item-c" }
const _hoisted_27 = { class: "item-quantity" }
const _hoisted_28 = { class: "item-maker" }
const _hoisted_29 = { class: "item-title" }
const _hoisted_30 = { class: "list-item-r" }
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "banner",
  src: _imports_4
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "gift",
  src: _imports_5
}, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, "以下をお読み頂き、応募してください。", -1))
const _hoisted_35 = { class: "checkbox" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "warning-message" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "align-center" }
const _hoisted_41 = {
  key: 0,
  class: "campaign-container post"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "joe" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_6 })
], -1))
const _hoisted_43 = { class: "campaign post" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 応募が完了しました！")
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = { style: {"margin-top":"1em","font-size":"0.9rem"} }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_49 = [
  _hoisted_48
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CampaignTerms = _resolveComponent("CampaignTerms")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["align-center", _ctx.showWindow ? 'clickable' : '']),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeWindow && _ctx.closeWindow(...args)))
    }, [
      _createVNode(_Transition, { name: "bounce" }, {
        default: _withCtx(() => [
          (_ctx.showWindow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                (_ctx.campaign)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("p", null, [
                        _createTextVNode(" 「毎月抽選で" + _toDisplayString(_ctx.total) + "名様に当たる！", 1),
                        _hoisted_5,
                        _hoisted_6,
                        _hoisted_7,
                        _hoisted_8,
                        _hoisted_9,
                        _hoisted_10,
                        _hoisted_11,
                        _hoisted_12,
                        _hoisted_13,
                        _hoisted_14,
                        _hoisted_15
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "back",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeWindow && _ctx.closeWindow(...args)))
                }, _hoisted_17)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_Transition, { name: "bounce" }, {
        default: _withCtx(() => [
          (_ctx.showApplyWindow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                (_ctx.campaign)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["campaign main", _ctx.campaign.type])
                    }, [
                      _createElementVNode("div", null, [
                        (_ctx.campaign.list)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_21,
                              _hoisted_22,
                              _createElementVNode("div", _hoisted_23, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaign.list, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: _normalizeClass({ selected: _ctx.campaignSelectItem === index }),
                                    onClick: ($event: any) => (_ctx.select(index))
                                  }, [
                                    _createElementVNode("div", _hoisted_25, [
                                      _createElementVNode("label", null, _toDisplayString(item.type) + "賞", 1),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["custom-checkbox", { checked: _ctx.campaignSelectItem === index }])
                                      }, null, 2)
                                    ]),
                                    _createElementVNode("div", _hoisted_26, [
                                      _createElementVNode("p", _hoisted_27, _toDisplayString(item.quantity) + "名様", 1),
                                      _createElementVNode("p", _hoisted_28, _toDisplayString(item.maker), 1),
                                      _createElementVNode("p", _hoisted_29, _toDisplayString(item.title), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_30, [
                                      _createElementVNode("img", {
                                        src: item.image
                                      }, null, 8, _hoisted_31)
                                    ])
                                  ], 10, _hoisted_24))
                                }), 128))
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_32,
                              _hoisted_33,
                              _hoisted_34
                            ], 64)),
                        _createVNode(_component_CampaignTerms, {
                          "is-new-member": !_ctx.campaign.list,
                          items: _ctx.campaign.list
                        }, null, 8, ["is-new-member", "items"]),
                        _createElementVNode("div", _hoisted_35, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.applyCheck) = $event)),
                            type: "checkbox",
                            id: "accept"
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.applyCheck]
                          ]),
                          _createElementVNode("label", {
                            for: "accept",
                            class: _normalizeClass({ accept: _ctx.applyCheck })
                          }, "同意する", 2)
                        ]),
                        _createElementVNode("button", {
                          class: _normalizeClass(["apply-button", { accept: _ctx.applyCheck }]),
                          disabled: !_ctx.applyCheck,
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args)))
                        }, " 応募する ", 10, _hoisted_36),
                        _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.applyMessage), 1)
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "back",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeWindow && _ctx.closeWindow(...args)))
                }, _hoisted_39)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createVNode(_Transition, { name: "bounce" }, {
        default: _withCtx(() => [
          (_ctx.showPostWindow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, [
                  (_ctx.isPostSuccess)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("p", null, [
                          _hoisted_44,
                          _hoisted_45,
                          _createTextVNode("当選者の発表は" + _toDisplayString(_ctx.campaign?.campaignType === "newMember"
                  ? "ギフトコードのお送り"
                  : "賞品の発送") + "をもって代えさせていただきます。 ", 1)
                        ]),
                        _createElementVNode("p", _hoisted_46, " ※" + _toDisplayString(_ctx.campaign?.campaignType === "newMember"
                  ? "ギフトコードのお送り"
                  : "賞品の発送") + "は、応募の翌々月を予定していますが諸事情により前後する可能性がございます。 ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock("p", _hoisted_47, "応募に失敗しました。"))
                ]),
                _createElementVNode("button", {
                  class: "back",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeWindow && _ctx.closeWindow(...args)))
                }, _hoisted_49)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ], 64))
}